module.exports = __webpack_public_path__ + "img/downloadCircle-icon-blue.348a4c8c.svg";